// if #landing_page_form is present, slide the anchor link in from the right after the page has scrolled past the fold
if (document.querySelector('#landing_page_form')) {
  console.log('landing_page_form found');
  const formCTA = document.querySelector('#landing_page_form');
  formCTA.style.right = '-400px'; // initial position off-screen

  // remove u--display-none class after 1 second
  setTimeout(() => {
    formCTA.classList.remove('u--display-none');
  }, 1000);

  window.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight) {
      formCTA.style.transition = 'right 0.75s ease-in-out';
      formCTA.style.right = '0px'; // slide in
    } else {
      formCTA.style.transition = 'right 0.75s ease-in-out';
      formCTA.style.right = '-400px'; // slide out
    }
  });
}

// Scroll to form if success message is visible
document.addEventListener('DOMContentLoaded', scollToForm);
function scollToForm() {
  const successMessage = document.getElementById('contact-form-success');
  if (
    successMessage &&
    !successMessage.classList.contains('u--display-none') &&
    !successMessage.classList.contains('scrolled-to')
  ) {
    const formElement = document.querySelector('.wpcf7');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });

      // Add class to flag that we've scrolled to prevent repeated scrolling
      successMessage.classList.add('scrolled-to');
    }
  }
}
